import { NgModule } from '@angular/core';

import { MasterCreateUserWizardActions } from './master-create-user-wizard.actions';

@NgModule({
  providers: [
    MasterCreateUserWizardActions
  ]
})
export class MasterCreateUserWizardActionsModule {}
